import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  searchFilterWrap: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 24px',
    margin: '16px 0px 24px',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },

    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
  searchWrap: {
    width: '100%',
  },
  fixedWidthTable: {
    '& .MuiTable-root': {
      tableLayout: 'fixed',
      width: '100%',
    },
    '& .MuiTableCell-root': {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
    // Tighter padding and type keep every column on screen without horizontal scrolling.
    // Horizontal padding is kept smaller than vertical so columns sit closer together.
    // Nested under .MuiTable-root so it outweighs the padding the table sets per cell.
    '& .MuiTable-root .MuiTableCell-head': {
      padding: '10px 6px',
      fontSize: 11,
      lineHeight: 1.4,
    },
    '& .MuiTable-root .MuiTableCell-body': {
      padding: '12px 6px',
      fontSize: 13,
      lineHeight: 1.4,
    },
  },
}));

export default useStyles;
